<template>
  <ul
    id="main-menu-navigation"
    class="nav navbar-nav"
    style="background: transparent;justify-content: center;">
    <component
      :is="resolveNavComponent(item)"
      v-for="item in items"
      :key="item.header || item.title"
      :item="item"
      :statistics="statistics"
    />
  </ul>
</template>

<script>
import store from '@/store'
import { onUnmounted, provide, ref } from '@vue/composition-api'
import layoutVerticalStoreModule from '@core/layouts/layout-vertical/layoutVerticalStoreModule'
import HorizontalNavMenuHeaderGroup from '../horizontal-nav-menu-header-group/HorizontalNavMenuHeaderGroup.vue'
import HorizontalNavMenuHeaderLink from '../horizontal-nav-menu-header-link/HorizontalNavMenuHeaderLink.vue'

export default {
  components: {
    HorizontalNavMenuHeaderLink,
    HorizontalNavMenuHeaderGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      interval: null,
    }
  },
  computed: {
    statistics() {
      return this.$store.getters['app/getMenuStatistics']
    },
  },
  setup() {
    provide('openGroups', ref([]))

    const MENU_STATISTICS_APP_STORE_MODULE_NAME = 'app-menu-statistics'

    // Register module
    if (!store.hasModule(MENU_STATISTICS_APP_STORE_MODULE_NAME)) store.registerModule(MENU_STATISTICS_APP_STORE_MODULE_NAME, layoutVerticalStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MENU_STATISTICS_APP_STORE_MODULE_NAME)) store.unregisterModule(MENU_STATISTICS_APP_STORE_MODULE_NAME)
    })

    const resolveNavComponent = item => {
      if (item.children) return 'horizontal-nav-menu-header-group'
      return 'horizontal-nav-menu-header-link'
    }

    return {
      resolveNavComponent,
    }
  },
}
</script>
